import { Outlet, createFileRoute, redirect } from "@tanstack/react-router"

import { PortalShell } from "@/components/portal-shell"
import { PageLoading } from "@/components/page-loading"
import { viewerQueryOptions } from "@/lib/query-options"

export const Route = createFileRoute("/portal")({
  beforeLoad: async ({ context }) => {
    const viewer =
      await context.queryClient.ensureQueryData(viewerQueryOptions())

    if (!viewer) {
      throw redirect({ to: "/login" })
    }

    return { viewer }
  },
  pendingComponent: PageLoading,
  head: () => ({
    meta: [{ title: "Imagery portal · Service Portal demo" }],
  }),
  component: PortalLayout,
})

function PortalLayout() {
  const { viewer } = Route.useRouteContext()

  return (
    <PortalShell viewer={viewer} mode="analyst">
      <Outlet />
    </PortalShell>
  )
}
